import {
  Squares2X2Icon,
  UsersIcon,
  DocumentTextIcon,
  CurrencyDollarIcon,
  VideoCameraIcon,
  ShieldCheckIcon,
  AdjustmentsHorizontalIcon,
  TagIcon,
  BookOpenIcon,
  ClipboardDocumentListIcon,
  ArrowPathIcon,
  RectangleStackIcon,
  ScaleIcon,
  BeakerIcon,
  ArrowsRightLeftIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

export interface NavItem {
  label: string;
  path: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  children?: NavItem[];
}

export const navigation: NavItem[] = [
  { label: 'Dashboard', path: '/', icon: Squares2X2Icon },
  {
    label: 'Entraînement',
    path: '/zones',
    icon: BookOpenIcon,
    children: [
      { label: 'Séances', path: '/workouts', icon: ClipboardDocumentListIcon },
      { label: 'Cycles', path: '/cycles', icon: ArrowPathIcon },
      { label: 'Plans', path: '/plans', icon: RectangleStackIcon },
      { label: 'Simulateur', path: '/simulator', icon: BeakerIcon },
      { label: 'Migration V1 → V2', path: '/migration', icon: ArrowsRightLeftIcon },
      { label: 'Conseils', path: '/guidance', icon: DocumentTextIcon },
      { label: 'Thématiques', path: '/themes', icon: TagIcon },
      { label: 'Scaling', path: '/scaling', icon: ScaleIcon },
      { label: 'Zones', path: '/zones', icon: AdjustmentsHorizontalIcon },
    ],
  },
  { label: 'Utilisateurs', path: '/users', icon: UsersIcon },
  { label: 'Vidéos', path: '/videos', icon: VideoCameraIcon },
  { label: 'Stripe', path: '/stripe', icon: CurrencyDollarIcon },
  { label: 'Beta allowlist', path: '/beta-allowlist', icon: ShieldCheckIcon },
];
